var v1="<span><span class=\"dropdown\"><button type=\"button\" data-toggle=\"dropdown\" ng-disabled=\"disable\" class=\"dropdown-toggle\"><span class=\"score\"></span></button><ul role=\"menu\" data-placement=\"auto\" class=\"dropdown-menu scrollable\"><li ng-if=\"emptyValue\" ng-click=\"updateModel()\"><a><div class=\"empty\"></div></a></li><li ng-class=\"{'active': isSelected(item)}\" ng-repeat=\"item in options\" ng-click=\"updateModel(item)\"><a ng-bind-html=\"item.text | trustedText\"></a></li></ul></span></span>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/form/custom-select.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/form/custom-select.jade
// module id = 250
// module chunks = 0